import { FC } from "react";
import { Tabs, TabsProps } from "antd";
import { clsx } from "clsx";
import classes from "./GenericTabs.module.less";

export const GenericTabs: FC<TabsProps> = ({ className, ...props }) => {
    const _className = clsx(classes.tabs, className);

    return <Tabs className={_className} {...props} />;
};
